import React, { useEffect, useState } from "react";
import {DownloadIcon, SearchIcon} from "~/assets/svg/InterfaceIcon";
import darkLogoImg from "~/assets/img/defaultImg/dark-logo-square.png";
import lightLogoImg from "~/assets/img/defaultImg/light-logo-square.png";
import Pagination from "~/common/constants/Pagination";
import { WarningIcon } from "~/assets/svg/AlertIcon";
import { useTranslation } from "react-i18next";
import { useGlobalStore } from "~/store";
import excel from '~/assets/img/icon/excel.png';
import useRequest from "~/common/hooks/useRequest";
import { API_STATE } from "~/common/constants/state";
import moment from "moment";
import { format } from "date-fns";
import useAlert from "~/common/hooks/useAlert";

const EvalRighttInfo = ({
	evalListData,
	setEvalFormData,
	evalFormData,
	viewEvalPopup,
	pageInfo,
	handlePage, roundInfo, isUserJudge
}) => {
	const { t } = useTranslation();
	const downloadRequest = useRequest("post", "/vc/round/review/excel/download");

	const [
		{
			theme: { theme },
		},
	] = useGlobalStore();

	const [searchInput, setSearchInput] = useState("");
	const [showWarningAlert, WarningAlert] = useAlert();
	const handleInput = (value) => {
		setSearchInput(value);
	};

	const handleSearch = () => {
		setEvalFormData({ ...evalFormData, name: searchInput, page: 1 });
	};

	const handleOpenDetail = (list) => {
		// 로그인한 유저가 심사역이 아니면 알림
		if(isUserJudge) {
			viewEvalPopup(list.idx);
		} else {
			showWarningAlert();
		}

	}



	const handleDownloadExcel = () => {
		downloadRequest.call(
			{ ...evalFormData }
			, 'body'
			, null
			, null
			, { responseType: 'blob' }
		);
	}
	useEffect(() => {
		switch (downloadRequest.state) {
			case API_STATE.done:
				const s2ab = (s) => {
					const buf = new ArrayBuffer(s.length);
					const view = new Uint8Array(buf);
					for (let i = 0; i < s.length; i++) {
						view[i] = s.charCodeAt(i) & 0xFF;
					}
					return buf;
				};

				// 이진 문자열 데이터
				const responseData = downloadRequest.response;

				const blob = new Blob([responseData]);

				// 다운로드 링크 생성 및 다운로드 실행
				const url = window.URL.createObjectURL(blob);
				const a = document.createElement('a');
				a.href = url;
				a.download = `${roundInfo.title}_지원결과_${moment(new Date).format("YYYYMMDD")}.xlsx`;
				document.body.appendChild(a);
				a.click();

				// 정리
				document.body.removeChild(a);
				window.URL.revokeObjectURL(url);

				break;
			default:
				break;
		}
	}, [downloadRequest.state, downloadRequest.response]);



	const handleDownloadZip = async (fileUrls) => {
		if (!fileUrls || fileUrls.length === 0) {
			console.error('파일 목록이 비어 있습니다.');
			return;
		}
		try {
			fileUrls.forEach((fileUrl, index) => {
				let iframe = document.createElement('iframe');
				iframe.style.display = 'none';
				iframe.src = fileUrl.url;
				document.body.appendChild(iframe);
				fnSleep(100);
			});
		} catch (error) {
			console.error('Error during file download:', error);
		}
	};

	//파일 간 시간 지연
	const fnSleep = (dTime) => {
		const start = new Date().getTime();
		while(start + dTime > new Date().getTime()) {}
	};


	return (
		<div className="c__card right">
			<div className="c__table">
				<div className="list-top">
					<div className="c__search with_excel">
						<img src={excel} onClick={handleDownloadExcel} />
						<input
							className="c__input"
							placeholder={t(
								"pages.round.RoundList.component.EvalRighttInfo.SearchPlaceholder"
							)}
							onChange={(e) => {
								handleInput(e.target.value);
							}}
							onKeyDown={(e) => {
								if (e.key === "Enter") {
									handleSearch();
								}
							}}
						/>
						<button type="button" className="btn-search" onClick={handleSearch}>
							<SearchIcon />
						</button>
					</div>
				</div>
				<div className="thead">
					<div className="tr">
						<div className="th company-num">No</div>
						<div className="th company-profile">
							{t("pages.round.RoundList.component.EvalRighttInfo.profile")}
						</div>
						<div className="th company-ceo">
							{t("pages.round.RoundList.component.EvalRighttInfo.ceo")}
						</div>
						<div className="th company-kind">
							{t("pages.round.RoundList.component.EvalRighttInfo.kind")}
						</div>
						<div className="th company-kind">
							지원일시
						</div>
						<div className="th company-status">
							{t("pages.round.RoundList.component.EvalRighttInfo.status")}
						</div>
						<div className="th company-evaluate">
							{t("pages.round.RoundList.component.EvalRighttInfo.evaluate")}
						</div>
						<div className="th company-evaluate">
							다운로드
						</div>
					</div>
				</div>
				<div className="tbody">
					{evalListData?.list?.length > 0 ? (
						evalListData?.list.map((list, idx) => {
							return (
								<div className="tr" onClick={() => handleOpenDetail(list)}>
									<div className="td company-num">{evalListData.total - (evalFormData.size * (evalFormData.page - 1) + idx)}</div>
									<div className="td company-profile">
										<div className="img-wrap">
											<img
												src={
													list.logoSqu
														? list.logoSqu
														: theme === "dark"
															? darkLogoImg
															: lightLogoImg
												}
												alt={t(
													"pages.round.RoundList.component.EvalRighttInfo.logo"
												)}
											/>
										</div>
										<div className="company-name">{list.companyName}</div>
									</div>
									<div className="td company-ceo">{list.ceoName}</div>
									<div className="td company-kind">{list.business}</div>
									<div className="td company-kind">{format(new Date(list.regDate), 'yy-MM-dd hh:mm')}</div>
									<div className="td company-status">{list.status}</div>
									<div className="td company-evaluate">
										<button
											type="button"
											className="btn__outline angled"
											color="primary"
										>
											{t(
												"pages.round.RoundList.component.EvalRighttInfo.doEvaluate"
											)}
										</button>

										{/*--------관망하기 버튼*/}
										{/*<button*/}
										{/*	type="button"*/}
										{/*	className="btn__outline angled btn-view"*/}
										{/*	color="green"*/}
										{/*>*/}
										{/*	관망하기*/}
										{/*</button>*/}
									</div>
									<div className="td company-evaluate">
										<button
											className={"download_button"}
											onClick={e => {
												e.stopPropagation();
												handleDownloadZip(list.fileList);
											}}
											disabled={!list.fileList || list.fileList?.length <= 0}
										>
											<DownloadIcon/>
										</button>
									</div>
								</div>
							);
						})
					) : (
						<div className="c__noData">
							<WarningIcon />
							<p className="main">
								{t("pages.round.RoundList.component.EvalRighttInfo.noData")}
							</p>
						</div>
					)}
				</div>
			</div>
			<Pagination pageInfo={pageInfo} handlePage={handlePage} />

			<WarningAlert
				type="warning"
				confirm={t("common.commonWord.button.check")}
				message={<>해당 지원 프로그램의 내부 심사역이 아닙니다.<br/>심사하기를 원하실 경우 내부 심사역으로 등록해주세요.</>}
			/>
		</div>
	);
};

export default EvalRighttInfo;
